import React from 'react'

/**
 * Ambient default for `ui2:entityPreviewCard`'s `showTypeStripe` prop.
 *
 * The card renders its color-coded left type-stripe by default. Result-list
 * containers (entity-search results, `ui:entitySelect` options) render many
 * cards at once, so the stripe would repeat down the column and add visual
 * noise; those containers wrap their children in this provider with
 * `showTypeStripe: false` to opt out. An explicit `showTypeStripe` prop on
 * the card always wins over the context value.
 */
export const EntityPreviewCardContext = React.createContext<{ showTypeStripe: boolean }>({
  showTypeStripe: true,
})
